import { Translation } from 'react-i18next'

const DataIndex = {
  current_page: 1,
  data: [
    {
      created_at: '2021-10-11T11:16:20.000000Z',
      deleted_at: null,
      description: 'He says it kills all the.',
      end_at: '2021-10-11 11:16:18',
      id: '2b36085c87023',
      merchants_count: 1,
      name: 'Jaskolski-Lemke',
      partner_id: '4584d83db961a',
      start_at: '2021-10-11 11:16:18',
      status: 'active',
      updated_at: '2021-10-11T11:16:20.000000Z',
      vouchers_count: 5,
    },
    {
      created_at: '2021-10-11T11:16:20.000000Z',
      deleted_at: null,
      description: 'He says it kills all the.',
      end_at: '2021-10-11 11:16:18',
      id: '2b36085c87023',
      merchants_count: 1,
      name: 'Jaskolski-Lemke',
      partner_id: '4584d83db961a',
      start_at: '2021-10-11 11:16:18',
      status: 'active',
      updated_at: '2021-10-11T11:16:20.000000Z',
      vouchers_count: 5,
    },
    {
      created_at: '2021-10-11T11:16:20.000000Z',
      deleted_at: null,
      description: 'He says it kills all the.',
      end_at: '2021-10-11 11:16:18',
      id: '2b36085c87023',
      merchants_count: 1,
      name: 'Jaskolski-Lemke',
      partner_id: '4584d83db961a',
      start_at: '2021-10-11 11:16:18',
      status: 'active',
      updated_at: '2021-10-11T11:16:20.000000Z',
      vouchers_count: 5,
    },
    {
      created_at: '2021-10-11T11:16:20.000000Z',
      deleted_at: null,
      description: 'He says it kills all the.',
      end_at: '2021-10-11 11:16:18',
      id: '2b36085c87023',
      merchants_count: 1,
      name: 'Jaskolski-Lemke',
      partner_id: '4584d83db961a',
      start_at: '2021-10-11 11:16:18',
      status: 'active',
      updated_at: '2021-10-11T11:16:20.000000Z',
      vouchers_count: 5,
    },
    {
      created_at: '2021-10-11T11:16:20.000000Z',
      deleted_at: null,
      description: 'He says it kills all the.',
      end_at: '2021-10-11 11:16:18',
      id: '2b36085c87023',
      merchants_count: 1,
      name: 'Jaskolski-Lemke',
      partner_id: '4584d83db961a',
      start_at: '2021-10-11 11:16:18',
      status: 'active',
      updated_at: '2021-10-11T11:16:20.000000Z',
      vouchers_count: 5,
    },
    {
      created_at: '2021-10-11T11:16:20.000000Z',
      deleted_at: null,
      description: 'He says it kills all the.',
      end_at: '2021-10-11 11:16:18',
      id: '2b36085c87023',
      merchants_count: 1,
      name: 'Jaskolski-Lemke',
      partner_id: '4584d83db961a',
      start_at: '2021-10-11 11:16:18',
      status: 'active',
      updated_at: '2021-10-11T11:16:20.000000Z',
      vouchers_count: 5,
    },
    {
      created_at: '2021-10-11T11:16:20.000000Z',
      deleted_at: null,
      description: 'He says it kills all the.',
      end_at: '2021-10-11 11:16:18',
      id: '2b36085c87023',
      merchants_count: 1,
      name: 'Jaskolski-Lemke',
      partner_id: '4584d83db961a',
      start_at: '2021-10-11 11:16:18',
      status: 'active',
      updated_at: '2021-10-11T11:16:20.000000Z',
      vouchers_count: 5,
    },
    {
      created_at: '2021-10-11T11:16:20.000000Z',
      deleted_at: null,
      description: 'He says it kills all the.',
      end_at: '2021-10-11 11:16:18',
      id: '2b36085c87023',
      merchants_count: 1,
      name: 'Jaskolski-Lemke',
      partner_id: '4584d83db961a',
      start_at: '2021-10-11 11:16:18',
      status: 'active',
      updated_at: '2021-10-11T11:16:20.000000Z',
      vouchers_count: 5,
    },
    {
      created_at: '2021-10-11T11:16:20.000000Z',
      deleted_at: null,
      description: 'He says it kills all the.',
      end_at: '2021-10-11 11:16:18',
      id: '2b36085c87023',
      merchants_count: 1,
      name: 'Jaskolski-Lemke',
      partner_id: '4584d83db961a',
      start_at: '2021-10-11 11:16:18',
      status: 'active',
      updated_at: '2021-10-11T11:16:20.000000Z',
      vouchers_count: 5,
    },
    {
      created_at: '2021-10-11T11:16:20.000000Z',
      deleted_at: null,
      description: 'He says it kills all the.',
      end_at: '2021-10-11 11:16:18',
      id: '2b36085c87023',
      merchants_count: 1,
      name: 'Jaskolski-Lemke',
      partner_id: '4584d83db961a',
      start_at: '2021-10-11 11:16:18',
      status: 'active',
      updated_at: '2021-10-11T11:16:20.000000Z',
      vouchers_count: 5,
    },
    {
      created_at: '2021-10-11T11:16:20.000000Z',
      deleted_at: null,
      description: 'He says it kills all the.',
      end_at: '2021-10-11 11:16:18',
      id: '2b36085c87023',
      merchants_count: 1,
      name: 'Jaskolski-Lemke',
      partner_id: '4584d83db961a',
      start_at: '2021-10-11 11:16:18',
      status: 'active',
      updated_at: '2021-10-11T11:16:20.000000Z',
      vouchers_count: 5,
    },
  ],
  first_page_url: 'http://partner.docker/campaigns?page=1',
  from: 1,
  last_page: 1,
  last_page_url: 'http://partner.docker/campaigns?page=1',
  links: [
    {
      active: false,
      label: '&laquo; Previous',
      url: null,
    },
    {
      active: true,
      label: '1',
      url: 'http://partner.docker/campaigns?page=1',
    },
    {
      active: false,
      label: 'Next &raquo;',
      url: null,
    },
  ],
  next_page_url: null,
  path: 'http://partner.docker/campaigns',
  per_page: 10,
  prev_page_url: null,
  to: 9,
  total: 9,
}

const DataVoucher = [
  {
    id: 1,
    exDate: '12-12-2012',
    total: '1000',
    price: '100000',
    categories: ['Technology', 'Travel', 'Beautify'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'CoffeeHouse',
    value: 134,
    type: 'premium',
    limit_min: 10,
  },
  {
    id: 2,
    exDate: '12-12-2012',
    total: '2000',
    price: '85000',
    categories: ['Beautify', 'Nittle', 'Banner'],
    name: 'Gift Code Card',
    status: 'Best Price',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-1.jpg',
    merchant: 'CoffeeHouse',
    value: 1346,
    type: 'premium',
    limit_min: 10,
  },
  {
    id: 3,
    exDate: '12-12-2012',
    total: '500',
    price: '15000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Best Price',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'CoffeeHouse',
    value: 122,
    type: 'premium',
    limit_min: 10,
  },
  {
    id: 4,
    exDate: '12-12-2012',
    total: '1200',
    price: '40000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-2.jpg',
    merchant: 'CoffeeHouse',
    value: 152,
    type: 'premium',
    limit_min: 10,
  },
  {
    id: 5,
    exDate: '12-12-2012',
    total: '2200',
    price: '120000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-1.jpg',
    merchant: 'CoffeeHouse',
    value: 146,
    type: 'premium',
    limit_min: 10,
  },
  {
    id: 6,
    exDate: '12-12-2012',
    total: '40100',
    price: '10000',
    categories: ['Travel', 'Book', 'Shopping'],
    name: 'Gift Code Card',
    status: 'Best Price',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'CoffeeHouse',
    value: 123,
    type: 'premium',
    limit_min: 10,
  },
  {
    id: 7,
    exDate: '12-12-2012',
    total: '3300',
    price: '90000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-2.jpg',
    merchant: 'CoffeeHouse',
    value: 164,
    type: 'premium',
    limit_min: 10,
  },
  {
    id: 8,
    exDate: '12-12-2012',
    total: '6600',
    price: '79000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'CoffeeHouse',
    value: 151,
    type: 'premium',
    limit_min: 10,
  },
  {
    id: 9,
    exDate: '12-12-2012',
    total: '1000',
    price: '100000',
    categories: ['Technology', 'Travel', 'Beautify'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'CoffeeHouse',
    value: 134,
    type: 'premium',
    limit_min: 10,
  },
  {
    id: 10,
    exDate: '12-12-2012',
    total: '2000',
    price: '85000',
    categories: ['Beautify', 'Nittle', 'Banner'],
    name: 'Gift Code Card',
    status: 'Best Price',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-1.jpg',
    merchant: 'CoffeeHouse',
    value: 1346,
    type: 'premium',
    limit_min: 10,
  },
  {
    id: 11,
    exDate: '12-12-2012',
    total: '500',
    price: '15000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Best Price',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'Lazada',
    value: 122,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 12,
    exDate: '12-12-2012',
    total: '1200',
    price: '40000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-2.jpg',
    merchant: 'Lazada',
    value: 152,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 13,
    exDate: '12-12-2012',
    total: '2200',
    price: '120000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-1.jpg',
    merchant: 'Lazada',
    value: 146,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 14,
    exDate: '12-12-2012',
    total: '40100',
    price: '10000',
    categories: ['Travel', 'Book', 'Shopping'],
    name: 'Gift Code Card',
    status: 'Best Price',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'Lazada',
    value: 123,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 15,
    exDate: '12-12-2012',
    total: '3300',
    price: '90000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-2.jpg',
    merchant: 'Lazada',
    value: 164,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 16,
    exDate: '12-12-2012',
    total: '6600',
    price: '79000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'Lazada',
    value: 151,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 17,
    exDate: '12-12-2012',
    total: '1000',
    price: '100000',
    categories: ['Technology', 'Travel', 'Beautify'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'Lazada',
    value: 134,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 18,
    exDate: '12-12-2012',
    total: '2000',
    price: '85000',
    categories: ['Beautify', 'Nittle', 'Banner'],
    name: 'Gift Code Card',
    status: 'Best Price',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-1.jpg',
    merchant: 'Lazada',
    value: 1346,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 19,
    exDate: '12-12-2012',
    total: '500',
    price: '15000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Best Price',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'Lazada',
    value: 122,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 20,
    exDate: '12-12-2012',
    total: '1200',
    price: '40000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-2.jpg',
    merchant: 'Lazada',
    value: 152,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 21,
    exDate: '12-12-2012',
    total: '2200',
    price: '120000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-1.jpg',
    merchant: 'Vietnamairline',
    value: 146,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 22,
    exDate: '12-12-2012',
    total: '40100',
    price: '10000',
    categories: ['Travel', 'Book', 'Shopping'],
    name: 'Gift Code Card',
    status: 'Best Price',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'Vietnamairline',
    value: 123,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 23,
    exDate: '12-12-2012',
    total: '3300',
    price: '90000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-2.jpg',
    merchant: 'Vietnamairline',
    value: 164,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 24,
    exDate: '12-12-2012',
    total: '6600',
    price: '79000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'Vietnamairline',
    value: 151,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 25,
    exDate: '12-12-2012',
    total: '1000',
    price: '100000',
    categories: ['Technology', 'Travel', 'Beautify'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'Vietnamairline',
    value: 134,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 26,
    exDate: '12-12-2012',
    total: '2000',
    price: '85000',
    categories: ['Beautify', 'Nittle', 'Banner'],
    name: 'Gift Code Card',
    status: 'Best Price',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-1.jpg',
    merchant: 'Vietnamairline',
    value: 1346,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 27,
    exDate: '12-12-2012',
    total: '500',
    price: '15000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Best Price',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'Vietnamairline',
    value: 122,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 28,
    exDate: '12-12-2012',
    total: '1200',
    price: '40000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-2.jpg',
    merchant: 'Vietnamairline',
    value: 152,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 29,
    exDate: '12-12-2012',
    total: '2200',
    price: '120000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-1.jpg',
    merchant: 'Vietnamairline',
    value: 146,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 30,
    exDate: '12-12-2012',
    total: '40100',
    price: '10000',
    categories: ['Travel', 'Book', 'Shopping'],
    name: 'Gift Code Card',
    status: 'Best Price',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'Vietnamairline',
    value: 123,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 31,
    exDate: '12-12-2012',
    total: '3300',
    price: '90000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-2.jpg',
    merchant: 'Vietnamairline',
    value: 164,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 32,
    exDate: '12-12-2012',
    total: '6600',
    price: '79000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'Vietnamairline',
    value: 151,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 33,
    exDate: '12-12-2012',
    total: '1000',
    price: '100000',
    categories: ['Technology', 'Travel', 'Beautify'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'Shopee',
    value: 134,
    type: 'standard',
  },
  {
    id: 34,
    exDate: '12-12-2012',
    total: '2000',
    price: '85000',
    categories: ['Beautify', 'Nittle', 'Banner'],
    name: 'Gift Code Card',
    status: 'Best Price',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-1.jpg',
    merchant: 'Shopee',
    value: 1346,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 35,
    exDate: '12-12-2012',
    total: '500',
    price: '15000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Best Price',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'Shopee',
    value: 122,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 36,
    exDate: '12-12-2012',
    total: '1200',
    price: '40000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-2.jpg',
    merchant: 'Shopee',
    value: 152,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 37,
    exDate: '12-12-2012',
    total: '2200',
    price: '120000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-1.jpg',
    merchant: 'Shopee',
    value: 146,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 38,
    exDate: '12-12-2012',
    total: '40100',
    price: '10000',
    categories: ['Travel', 'Book', 'Shopping'],
    name: 'Gift Code Card',
    status: 'Best Price',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'Shopee',
    value: 123,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 39,
    exDate: '12-12-2012',
    total: '3300',
    price: '90000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-2.jpg',
    merchant: 'Shopee',
    value: 164,
    type: 'standard',
    limit_min: 10,
  },
  {
    id: 40,
    exDate: '12-12-2012',
    total: '6600',
    price: '79000',
    categories: ['Travel', 'Beautify', 'Shipping'],
    name: 'Gift Code Card',
    status: 'Hot Sale',
    image:
      'https://www.vietnambooking.com/wp-content/uploads/2020/03/ve-may-bay-vietnam-airlines-thang-4-11012021-3.jpg',
    merchant: 'Shopee',
    value: 151,
    type: 'standard',
    limit_min: 10,
  },
]

const DataFilter = [
  {
    Header: 'HOME.NAME',
    autoHide: undefined,
    displayName: 'HOME.NAME',
    id: 'name',
    name: 'name',
    type: 'string',
    value: '',
  },
  {
    Header: 'HOME.CATEGORIES',
    autoHide: undefined,
    displayName: 'HOME.CATEGORIES',
    id: 'categories',
    name: 'categories',
    options: [
      { value: 'Shopping', name: 'Shopping' },
      { value: 'Foods', name: 'Foods' },
      { value: 'Coffeee', name: 'Coffeee' },
      { value: 'Clothes', name: 'Clothes' },
    ],
    type: 'singleSelect',
    value: '',
  },
  {
    id: 'tags',
    Header: 'HOME.TAGS',
    accessor: 'tag_lists',
    type: 'multiSelect',
    router: 'partner.home',
    options: [],
    only: 'tags',
  },
  {
    Header: 'HOME.TYPE',
    displayName: 'HOME.TYPE',
    options: [
      { value: 'premium', name: <Translation>{(t) => t('VOUCHERS.PREMIUM')}</Translation> },
      { value: 'standard', name: <Translation>{(t) => t('VOUCHERS.STANDARD')}</Translation> },
    ],
    autoHide: true,
    id: 'type',
    name: 'type',
    type: 'singleSelect',
    accessor: 'type',
    value: '',
  },
  {
    Header: 'HOME.MERCHANT',
    autoHide: true,
    displayName: 'HOME.MERCHANT',
    id: 'merchant_name',
    name: 'merchant_name',
    type: 'string',
    value: '',
  },
  {
    Header: 'HOME.IN_STOCK',
    autoHide: true,
    displayName: 'HOME.IN_STOCK',
    id: 'available_codes',
    name: 'available_codes',
    accessor: 'available_codes',
    type: 'number',
    value: '',
  },
  {
    Header: 'HOME.DATE_OF_EXPIRY',
    displayName: 'expired_date',
    id: 'expired_date',
    accessor: 'expired_date',
    type: 'dateTime',
    name: 'expired_date',
    autoHide: true,
    value: '',
  },

  {
    Header: 'Price',
    autoHide: true,
    id: 'price',
    name: 'price',
    type: 'price',
    accessor: 'price',
    value: '',
  },

  {
    Header: 'HOME.MIN_PRICE',
    autoHide: true,
    id: 'min_price',
    name: 'min_price',
    type: 'min_price',
    accessor: 'min_price',
    value: '',
  },

  {
    Header: 'HOME.MAX_PRICE',
    autoHide: true,
    id: 'max_price',
    name: 'max_price',
    type: 'max_price',
    accessor: 'max_price',
    value: '',
  },
]

const DataPaging = [
  {
    page: 1,
  },
]

export { DataIndex, DataFilter, DataVoucher, DataPaging }
